import { useState, useEffect } from 'preact/hooks';
// Custom hook for reactive mobile detection
export function useIsMobile(breakpoint = 690) {
    const [isMobile, setIsMobile] = useState(() => {
        // Initial value based on current window size
        if (typeof window !== 'undefined') {
            return window.innerWidth <= breakpoint;
        }
        return false;
    });
    useEffect(() => {
        // Return early if window is not available (SSR)
        if (typeof window === 'undefined') {
            return;
        }
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= breakpoint);
        };
        // Add event listener for window resize
        window.addEventListener('resize', checkIsMobile);
        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', checkIsMobile);
        };
    }, [breakpoint]);
    return isMobile;
}
// Custom hook for reactive media query matching
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    });
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const mediaQuery = window.matchMedia(query);
        const handleChange = (event) => {
            setMatches(event.matches);
        };
        // Set initial value
        setMatches(mediaQuery.matches);
        // Add listener for changes
        if (mediaQuery.addListener) {
            mediaQuery.addListener(handleChange);
        }
        else {
            // Modern browsers
            mediaQuery.addEventListener('change', handleChange);
        }
        // Cleanup
        return () => {
            if (mediaQuery.removeListener) {
                mediaQuery.removeListener(handleChange);
            }
            else {
                mediaQuery.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
// Predefined breakpoints
export const BREAKPOINTS = {
    mobile: 690,
    mouMobile: 980,
    tablet: 768,
    desktop: 1024,
    large: 1280,
};
export const useIsMouMobile = () => useIsMobile(BREAKPOINTS.mouMobile);
// Convenience hooks for common breakpoints
export const useIsTablet = () => useMediaQuery(`(min-width: ${BREAKPOINTS.tablet}px)`);
export const useIsDesktop = () => useMediaQuery(`(min-width: ${BREAKPOINTS.desktop}px)`);
